import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import { RecoilRoot } from 'recoil';

document.addEventListener("keyup", function (event) {
  if (event.key === "PrintScreen") {
    navigator.clipboard.writeText('');
    // alert("スクリーンキャプチャは無効化されています。");
  }
});
document.addEventListener('selectstart', function (event) {
  event.preventDefault();
});
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
